export const tripodContent = {
  steps: [
    {
      iconName: "user-check",
      header: "załóż konto",
      firstRowText:
        "W następnym kroku założysz konto dla usług z subskrypcją (nju subskrypcja i nju światłowód).",
      secondRowText: undefined,
    },
    {
      iconName: "file-alt",
      header: "dopasuj ofertę i zaznacz zgody",
      firstRowText:
        "Następnie wybierzesz, ile numerów potrzebujesz oraz zdecydujesz, co chcesz zrobić z każdym z nich.",
      secondRowText:
        "Możesz przenieść numer od innego operatora lub wybrać nowy.",
    },
    {
      iconName: "shopping-basket",
      header: "dokończ zakup",
      firstRowText:
        "Na koniec opłacisz swoje zamówienie dzięki wygodnym płatnościom online.",
      secondRowText: "Do wyboru masz kartę, BLIK i płatność online.",
    },
  ],
} as const;
